import { api, apiUrl } from "./../../api/index";

const paypalPaymentsUrl = `${apiUrl}/paypal`;

export const fetchPaypalPayments = () => {
  return api(`${paypalPaymentsUrl}/all`, {
    method: "GET",
  });
};
